import * as React from 'react';
import * as _ from 'lodash';
import PopupWrapper from '../../../../components/Popup/PopupWrapper';
import PopupHeader from '../../../../components/Popup/PopupHeader';
import PopupBody from '../../../../components/Popup/PopupBody';
import PopupButtons from '../../../../components/Popup/PopupButtons';
import PopupButton from '../../../../components/Popup/PopupButton';
import { CodeMirrorType } from '../../../../../models/CodeMirrorType';
import { useCallback, useEffect, useRef, useState } from 'react';
import getCodeMirrorInstance from '../../../../../services/mini/getCodeMirrorInstance';
import { defaultTransformColumnFormat } from '../transformFormats';
import addTabSpacesTotextarea from '../../../../../services/mini/addTabSpacesTotextarea';
import { HIGLIGHT_TOP_INSTRUCTION_RULES } from '../transformTextHighlight';
import { useClosePopup } from '../../../../../hooks/useClosePopup';
import { observer } from 'mobx-react';
import { transformsStore } from '../../../../../mobx/transforms.store';
import { ITransform } from '../../../../../models/ITransform';


type TransformTopInstructionPopupViewProps = {
    initValue: string
    title: string
    placeholder?: string
    format?: string
    editable: boolean
    hideFormatSelector: boolean
    onClose: () => void;
    savedTransform: ITransform
}
function TransformTopInstructionPopupView({ onClose, initValue, title, format, editable, savedTransform }: TransformTopInstructionPopupViewProps) {

    const [curValue, setCurValue] = useState(initValue);
    const [selectedFormat, setSelectedFormat] = useState(format || defaultTransformColumnFormat);
    const [isJsonValid, setIsJsonValid] = React.useState(true);
    const ref = React.useRef<CodeMirrorType>();

    const hasChanges = savedTransform?.header?.prompt?.value !== curValue;

    const onCancelCb = useCallback(() => {
        onClose();
    }, [onClose]);

    useEffect(() => {
        if (editable) {
            getCodeMirrorInstance(ref.current)?.focus();
        }
    }, [editable]);

    useClosePopup(onClose);

    const handleTextareaKeydown = useCallback((e) => {
        addTabSpacesTotextarea(e);
        setCurValue(e.target.value);
    }, []);

    const containerRef = useRef();

    useEffect(() => {
        try {
            window.$('.textarea-with-highlighted-top-instruction-text-in-popup', containerRef?.current).highlightWithinTextarea({
                highlight: HIGLIGHT_TOP_INSTRUCTION_RULES
            });
        } catch (error) {
            console.info('err', error);
        }
    }, []);

    return (
        <PopupWrapper className={`transform-top-instruction-popup ${selectedFormat} ${!editable ? 'read-only-mode' : ''}`}>
            <PopupHeader
                title={`${editable ? 'Edit' : 'View'} ${title}`}
                onCancel={onCancelCb} />
            <PopupBody>
                <div className="transform-top-instruction-popup__text-wrapper" ref={containerRef}>
                    <textarea
                        className={`textarea-with-highlighted-top-instruction-text-in-popup`}
                        value={curValue}
                        readOnly={!editable}
                        onChange={(e) => {
                            setCurValue(e.target.value);
                            transformsStore.updateMainPrompt(e.target.value);
                        }}
                        onKeyDown={handleTextareaKeydown}
                    />
                </div>

            </PopupBody>
            <PopupButtons>
                {editable &&
                    <PopupButton
                        className={`light-red-with-border discard-btn ${!isJsonValid && selectedFormat === 'json' ? 'disabled' : ''} ${hasChanges ? '' : 'disabled'}`}
                        label="Discard changes"
                        action={() => {
                            const newVal = savedTransform?.header?.prompt?.value;
                            setCurValue(newVal);
                            transformsStore.updateMainPrompt(newVal);
                        }} />}

                <PopupButton
                    className={`transform-top-instruction-popup__ok-btn ${!isJsonValid && selectedFormat === 'json' ? 'disabled' : ''}`}
                    label="Back to transform"
                    action={onClose} />
            </PopupButtons>
        </PopupWrapper>


    );
}
export const TransformTopInstructionPopup = observer(TransformTopInstructionPopupView);